function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M.109,57.806v46.987a.9.9,0,0,0,.9.9H35.35a.9.9,0,0,0,.9-.9V66.842c0-.02-.01-.037-.012-.057a.852.852,0,0,0-.046-.232c-.01-.029-.017-.057-.03-.085a.9.9,0,0,0-.181-.265l-9.036-9.036a.876.876,0,0,0-.266-.181.816.816,0,0,0-.083-.03.9.9,0,0,0-.234-.047c-.015,0-.033-.007-.052-.007H1.013A.9.9,0,0,0,.109,57.806Zm33.059,8.132H27.217V59.987ZM1.916,58.709H25.41v8.132a.9.9,0,0,0,.9.9h8.132v36.144H1.916Zm0,0",
  transform: "translate(-0.109 -51.481)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M89.537,46.987v1.807h2.711a.9.9,0,0,0,.9-.9V.9a.9.9,0,0,0-.9-.9H57.911a.9.9,0,0,0-.9.9V3.614h1.807V1.807H91.344v45.18Zm0,0",
  transform: "translate(-51.586)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M75.977,189.668H97.663v1.807H75.977Zm0,0",
  transform: "translate(-68.748 -171.596)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M75.977,132.766h7.229v1.807H75.977Zm0,0",
  transform: "translate(-68.748 -120.115)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M75.977,246.566H90.434v1.807H75.977Zm0,0",
  transform: "translate(-68.748 -223.073)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M246.676,246.566H252.1v1.807h-5.421Zm0,0",
  transform: "translate(-223.182 -223.073)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M75.977,303.465H97.663v1.807H75.977Zm0,0",
  transform: "translate(-68.748 -274.55)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M75.977,417.266H97.663v1.807H75.977Zm0,0",
  transform: "translate(-68.748 -377.508)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M161.324,360.367h13.554v1.807H161.324Zm0,0",
  transform: "translate(-145.963 -326.031)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M75.977,360.367H82.3v1.807H75.977Zm0,0",
  transform: "translate(-68.748 -326.031)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M75.977,474.168h3.614v1.807H75.977Zm0,0",
  transform: "translate(-68.748 -428.988)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M132.875,474.168H149.14v1.807H132.875Zm0,0",
  transform: "translate(-120.225 -428.988)"
});

function SvgPapel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.565,
    height: 54,
    fill: "black",
    viewBox: "0 0 41.565 54.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapel);
export default __webpack_public_path__ + "static/media/Papel.3d9d1efd.svg";
export { ForwardRef as ReactComponent };